var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-inner"},[_c('div',{staticClass:"paragraph-content",class:_vm.layoutClass},[(_vm.block.content.subtitle)?_c('h5',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.block.content.subtitle))]):_vm._e(),_vm._v(" "),(_vm.block.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.block.content.wysiwyg)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }